var _rect, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 10,
    fill: "#54D4BD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_373_6303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 21,
    width: 24,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.333 29.333H26.6663C26.3127 29.333 25.9736 29.4735 25.7235 29.7235C25.4735 29.9736 25.333 30.3127 25.333 30.6663V47.9997C25.333 48.3533 25.4735 48.6924 25.7235 48.9425C25.9736 49.1925 26.3127 49.333 26.6663 49.333H45.333C45.6866 49.333 46.0258 49.1925 46.2758 48.9425C46.5259 48.6924 46.6663 48.3533 46.6663 47.9997V30.6663C46.6663 30.3127 46.5259 29.9736 46.2758 29.7235C46.0258 29.4735 45.6866 29.333 45.333 29.333Z",
    fill: "#555555",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.333 31.9998V27.3332C31.333 26.7203 31.4537 26.1135 31.6882 25.5473C31.9228 24.9811 32.2665 24.4667 32.6998 24.0333C33.1332 23.6 33.6476 23.2563 34.2138 23.0217C34.78 22.7872 35.3868 22.6665 35.9997 22.6665C36.6125 22.6665 37.2193 22.7872 37.7855 23.0217C38.3517 23.2563 38.8662 23.6 39.2995 24.0333C39.7328 24.4667 40.0766 24.9811 40.3111 25.5473C40.5456 26.1135 40.6663 26.7203 40.6663 27.3332V31.9998",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_373_6303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20H52V52H20V20Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMarketplace);
export default __webpack_public_path__ + "static/media/Icons-marketplace.2fe9c1f6593eccb0d3f63b5293e3b7dd.svg";
export { ForwardRef as ReactComponent };